import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute, notFound } from '@tanstack/react-router';

import { podcastDetailsQueryOptions } from '@/app/queries/projects/podcastDetails';
import { PodcastError, PodcastLoader } from '@/common/components/templates/podcast-page';
import { PodcastNotFound } from '@/common/components/templates/podcast-page/podcast-notfound';
import { ensureNotFound } from '@/infra/network/query';

function RouteComponent() {
  const { projeto: project, podcast } = Route.useParams();
  const { data } = useSuspenseQuery(podcastDetailsQueryOptions(project, podcast));

  if (!data) {
    return notFound();
  }

  return <Outlet />;
}

export const Route = createFileRoute('/_app/_dashboard/projetos/$projeto/podcast/$podcast')({
  component: RouteComponent,
  loader: ({ params, context }) =>
    ensureNotFound(
      context.queryClient.ensureQueryData(
        podcastDetailsQueryOptions(params.projeto, params.podcast),
      ),
    ),
  errorComponent: () => <PodcastError />,
  pendingComponent: () => <PodcastLoader />,
  notFoundComponent: () => <PodcastNotFound />,
  staleTime: Infinity,
  head: ({ match }) => ({
    meta: [
      {
        title: `${match.loaderData?.name} | Podcast AI`,
      },
    ],
  }),
});
